export default __webpack_public_path__ + "static/media/target.6e1a5080.svg";